import React from 'react';
import Icon from 'components/AppIcon';

const SlideNavigation = ({ 
  currentSlide, 
  totalSlides, 
  slides, 
  onNext, 
  onPrev, 
  onGoTo, 
  isFullscreen 
}) => {
  return (
    <div className={`${
      isFullscreen 
        ? 'fixed bottom-6 left-1/2 transform -translate-x-1/2' 
        : 'fixed bottom-6 right-6'
    } z-10`}>
      <div className="flex items-center space-x-4 bg-surface/90 backdrop-blur-sm rounded-lg shadow-lg p-3">
        {/* Previous Button */}
        <button
          onClick={onPrev}
          disabled={currentSlide === 0}
          className={`p-2 rounded-lg transition-smooth ${
            currentSlide === 0
              ? 'text-text-secondary cursor-not-allowed' :'text-text-primary hover:bg-secondary-100'
          }`}
          title="Previous Slide"
        >
          <Icon name="ChevronLeft" size={20} />
        </button>

        {/* Slide Indicators */}
        <div className="flex items-center space-x-2">
          {slides?.map((slide, index) => (
            <button
              key={index}
              onClick={() => onGoTo(index)}
              className={`w-3 h-3 rounded-full transition-smooth ${
                index === currentSlide
                  ? 'bg-primary' :'bg-secondary-300 hover:bg-secondary-400'
              }`}
              title={slide?.title}
            />
          ))}
        </div>

        {/* Slide Counter */}
        <div className="text-sm text-text-secondary font-medium">
          {currentSlide + 1}/{totalSlides}
        </div>

        {/* Next Button */}
        <button
          onClick={onNext}
          disabled={currentSlide === totalSlides - 1}
          className={`p-2 rounded-lg transition-smooth ${
            currentSlide === totalSlides - 1
              ? 'text-text-secondary cursor-not-allowed' :'text-text-primary hover:bg-secondary-100'
          }`}
          title="Next Slide"
        >
          <Icon name="ChevronRight" size={20} />
        </button>
      </div>

      {/* Keyboard Shortcuts Info */}
      {isFullscreen && (
        <div className="mt-3 text-center">
          <p className="text-xs text-text-secondary bg-surface/70 backdrop-blur-sm px-3 py-1 rounded-full">
            Use ←→ arrow keys or spacebar to navigate • ESC to exit fullscreen
          </p>
        </div>
      )}
    </div>
  );
};

export default SlideNavigation;